import { css } from 'styled-components';
import token from 'styled-token';

/** @class PhotoCarouselDotsMixin */
/** @method */
export var PhotoCarouselDotsMixin = function PhotoCarouselDotsMixin() {
  return token({
    backgroundColor: 'PhotoCarousel.dots.backgroundColor',
    borderRadius: 'PhotoCarousel.dots.borderRadius',
    bottom: 'PhotoCarousel.dot.position.bottom',
    maxDotHeight: 'PhotoCarousel.dot.size.lg',
    paddingX: 'PhotoCarousel.dots.paddingX',
    paddingY: 'PhotoCarousel.dots.paddingY'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      borderRadius = _ref.borderRadius,
      bottom = _ref.bottom,
      maxDotHeight = _ref.maxDotHeight,
      paddingX = _ref.paddingX,
      paddingY = _ref.paddingY;
    return css(["background-color:", ";border-radius:", ";padding:", "px ", "px;position:absolute;left:50%;transform:translateX(-50%);z-index:5;bottom:", "px;font-size:0;line-height:", "px;"], backgroundColor, borderRadius, paddingY, paddingX, bottom, maxDotHeight);
  });
};